import axios from "axios"

const createPcPosPaymentRequest = async (
  amount,
  ipAddress,
  comPort,
  posPort,
  merchantData = "test"
) => {
  const paymentDetails = {
    ConnectionType: "tcp",
    Amount: Math.round(amount * 10),
    PcId: "id",
    ComPort: comPort,
    BaudRate: 115200,
    PosIpAddress: ipAddress,
    PosPort: Number(posPort),
    MerchantData: merchantData
  }

  const header = {
    timeout: 10 * 60 * 1000
  }

  try {
    const response =
      await axios.post(
        "http://127.0.0.1:8080/payment",
        paymentDetails,
        header
      )

    return response.data
  } catch (err) {
    return { status: "Failed" }
  }
}

export default createPcPosPaymentRequest